module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-2-1-54b81e9f9b817eb369703865405e355e.png";